export const CARDS = {
  creditLimit: 1500,
  stampDuty: 30
};
